import { ApiServices, transformDataToQueryParameters } from 'tlv-auth/src/services/api/Api.service'
import { appType, appHeader } from 'tlv-auth/src/comp/AppType'

export const registerUserViaEmail = (data) => ApiServices.POST('v2', 'auth/register', data).json()
export const authorizeUserViaEmailAndPassword = (data) =>
  ApiServices.POST('v2', 'auth/authorize', data).json()
export const getAccessRefreshTokenByAuthorizationCode = (data) => {
  return ApiServices.POST('v2', 'auth/token', data).json()
}
export const refreshTokensCall = (refreshToken) =>
  ApiServices.POST('v2', `auth/refresh/${refreshToken}`, {}, { updateDataOnError: true }).json()
// export const refreshTokensCall = data => ApiServices.POST('v1', 'auth/refresh', data).json()
export const signOutUser = (data) => ApiServices.POST('v2', 'auth/sign-out', data)
export const verifyEmail = (id) => ApiServices.GET('v2', `auth/confirm-email/${id}`)
export const getPasswordResetLink = (email) => ApiServices.GET('v2', `auth/password-reset/${email}`)
export const setNewPassword = (code, data) =>
  ApiServices.POST('v2', `auth/reset-verify/${code}`, data).json()

export const getGoogleLoginLink = (data) => {
  const queryParameters = transformDataToQueryParameters(data)
  return `${ApiServices.API_BASE_URI()}v2/auth/google-login?app=${appType.value}&app-code=${appHeader.value}&${queryParameters}`
}

export const getAppleLoginLink = (data) => {
  const queryParameters = transformDataToQueryParameters(data)
  return `${ApiServices.API_BASE_URI()}v2/auth/apple-login?app=${appType.value}&app-code=${appHeader.value}&${queryParameters}`
}
